import { render, staticRenderFns } from "./EditHelpLinkSetting.vue?vue&type=template&id=88c53b42&scoped=true&"
import script from "./EditHelpLinkSetting.vue?vue&type=script&lang=js&"
export * from "./EditHelpLinkSetting.vue?vue&type=script&lang=js&"
import style0 from "./EditHelpLinkSetting.vue?vue&type=style&index=0&id=88c53b42&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88c53b42",
  null
  
)

export default component.exports